export default {
  name: '',
  permissionType: '',
  active: true
};
